import { gql } from 'graphql-tag';

export const GET_CENTRES_QUERY = gql`
    query GetCentres(
        $search: Ether_MapQuery,
        $types: [QueryArgument!],
        $order: String,
    ) {
        centres: transplantCentresEntries(
            centreAddress: $search,
            centreType: $types,
            orderBy: $order,
        ) {
            ... on default_Entry {
                id
                title
                email
                phone {
                    format(format: "INTERNATIONAL")
                }
                centreType
                centreAddress {
                    address
                    lat
                    lng
                    distance
                }
            }
        }
    }
`;
